import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import GS from '../grafsync/grafsync';
import MenuSelector from './MenuSelector';
import PrimaryButton from './PrimaryButton';
import TitledPanel from './TitledPanel';
import Warning from './Warning';
import { makeCancelable } from './utils/utils';
import LoadingButton from './LoadingButton';

const menuOptions = [
    {
        "value": "application/ld+json",
        "label": "JSON-LD"
    },
    {
        "value": "text/turtle",
        "label": "Turtle"
    },
    {
        "value": "application/rdf+xml",
        "label": "RDF/XML"
    },
    {
        "value": "application/n-triples",
        "label": "N-triples"
    }
];

class BasicDownload extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isErrored: false,
            format: "application/ld+json"
        };
        this.cancellable = null;
    }

    handleChange = (format) => this.setState({ format });

    download() {
        this.cancellable = makeCancelable(GS.download(this.props.exportName, this.props.resource, this.props.graph, this.state.format, [], true));
        return this.cancellable;
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    downloadData = async () => {
        this.setState({ isLoading: true });
        try {
            await this.download().promise;
            if (this.cancellable && this.cancellable.isCancelled()) return true;
            this.setState({
                isLoading: false,
                format: "application/ld+json"
            });
        }
        catch (e) {
            if (this.cancellable && this.cancellable.isCancelled()) return true;
            this.setState({
                isErrored: true,
                isLoading: false,
                errorMessage: e.message.includes("The payload is too large.") ?
                    e.message
                    :
                    "Could not download data for export."
            });
        }
    };

    onExitWarning = () => this.setState({ isErrored: false });

    render() {

        const { message, title, dataTest } = this.props;
        const { isErrored, isLoading, errorMessage } = this.state;

        if (isErrored) return <Warning message={errorMessage} onExitWarning={this.onExitWarning} />;

        return (
            <TitledPanel dataTest={dataTest} fontSize="large" height="full" title={title}>
                <Typography variant="body2" paragraph>{message}</Typography>
                <MenuSelector
                    dataTest="format-selector"
                    handleChange={this.handleChange}
                    selected="application/ld+json"
                    hintWord="format"
                    options={menuOptions} />
                <div style={{ marginTop: '20px', marginLeft: '2px', marginBottom: '2px' }}>
                    {isLoading ?
                        <LoadingButton disabled />
                        :
                        <PrimaryButton onClick={this.downloadData}>Download</PrimaryButton>
                    }
                </div>
            </TitledPanel>
        );
    }
}

BasicDownload.defaultProps = {
    title: "Download Data",
    dataTest: "data-download"
};

BasicDownload.propTypes = {
    dataTest: PropTypes.string,
    title: PropTypes.string,
    graph: PropTypes.string.isRequired,
    resource: PropTypes.string.isRequired,
    exportName: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired
};

export default BasicDownload;